// All are examples value only
export const LANDING_PAGE = "/api/v1/tracking/landing/page";
export const USER_ACTIVITY = "/api/v1/tracking/user/activity";
export const ORS_PAGE = "/api/v2/tracking/ors";
export const ATTACHMENT_ACTIVITY = "/api/v1/tracking/attachment";

export const DATA_TRACKING_API = "/api/v1/tvlk/events";
